import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.prototype.$axios = axios
Vue.config.productionTip = false

const messages = ['success', 'warning', 'info', 'error'];

messages.forEach(type => {
  ElementUI.Message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      };
      // 默认配置
      options.duration = 1500;
      options.showClose = true;
    }
    options.type = type;
    return ElementUI.Message(options);
  };
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
